import Navbar from "../components/navbar/Navbar";
import COTPortfolio from "../components/COT-portfolio/COTPortfolio";

function COTPortfolioScreen() {
  return (
    <div className="container-fluid bg-theme" style={{ height: "100vh" }}>
      <div className="row h-100">
          <div className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
            <div className="w-100 mb-2 flex-shrink-0">
              <Navbar />
            </div>
            <div className="flex-grow-1 px-2" style={{ minHeight: 0 }}>
              <COTPortfolio />
            </div>
          </div>
      </div>
    </div>
  );
}

export default COTPortfolioScreen;
